import { Configuration, PublicClientApplication, LogLevel } from "@azure/msal-browser";

export const TENANT_ID = import.meta.env.VITE_ENTRA_TENANT_ID as string;
export const CLIENT_ID = import.meta.env.VITE_ENTRA_APP_CLIENT_ID as string;
export const API_BASE = import.meta.env.VITE_API_BASE as string;

export const msalConfig: Configuration = {
  auth: {
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri: window.location.origin + "/auth-callback",
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      loggerCallback: (level, message) => {
        if (level <= LogLevel.Warning) console.warn("[msal]", message);
      },
    },
  },
};

export const apiScopes = [`api://${CLIENT_ID}/access_as_user`];

export const msalInstance = new PublicClientApplication(msalConfig);
